<template>
  <b-toast
    v-if="!isOverdueMessage || !zeroBalance"
    :id="'notification-' + notification.id"
    static
    no-auto-hide
    :visible="true"
    :variant="typeClass(notification.type)"
    class="shadow-none"
    :no-close-button="(simple) ? true : !notification.dismissable"
    :header-class="'d-none'"
    :body-class="['bg-'+ typeClass(notification.type), 'overflow-hidden', 'rounded', (simple) ? ['px-3', 'py-0'] : ['px-4', 'py-0', 'simple']]"
    toast-class="border-0 shadow-none"
    @hide="markRead(notification.id)"
  >
    <template v-if="hasContent" v-slot:default>
      <spinner v-if="busy" />
      <div v-else class="row inner-wrap align-items-center">
        <div :class="['col', 'text-left', 'py-2', 'position-relative',(!simple) ? 'py-md-3' : '']">
          <span v-if="dismissable" class="dismiss-button" @click="markRead">
            <font-awesome-icon :icon="['far', 'times-circle']" size="lg" />
          </span>
          <strong>{{ notification.subject }}</strong>
          <div class="notification__content">
            <component :is="compileContent(notification.content)" />
          </div>
        </div>
      </div>
    </template>
  </b-toast>
</template>

<script>
import Vue from 'vue';
import Spinner from "@/components/animation/Spinner";
import notification from "@/imports/mixins/notification";

const actionTest = /^(\[\[[a-zA-Z]*]])$/;
const OVERDUE_MESSAGE_ID = 7;

export default {
  name: "NotificationBlock",
  components: {Spinner},
  mixins: [notification],
  props: ['notification', 'simple'],
  data() {
    return {
      typeMap: {
        alert: "warning",
        info: "info",
        success: "success",
        high: "danger",
      },
      busy: false,
    }
  },
  computed: {
    hasContent: function() {
      return (this.notification.content && this.notification.content.length > 0);
    },
    dismissable: function() {
      return !this.isSystemMessage && this.notification.dismissable;
    },
    isSystemMessage: function() {
      return (this.notification.message_type && this.notification.message_type === 'system');
    },
    isOverdueMessage: function() {
      return this.notification.id === OVERDUE_MESSAGE_ID && this.isSystemMessage
    },
    zeroBalance: function () {
      return this.$store.state.company.ACCOUNT_BALANCE <= 0;
    }
  },
  methods: {
    typeClass: function(type){
      return this.typeMap[type] ?? this.typeMap["info"];
    },
    markRead: function() {
      this.$store.dispatch(this.isSystemMessage ? 'systemNotificationRead': 'notificationRead', {id:this.notification.id});
    },
    isLink: function(link) {
      return typeof link === "string" && !actionTest.test(link);
    },
    isAction: function(link) {
      return typeof link === "string" && actionTest.test(link);
    },
    executeAction(link) {
      if (this.isAction(link)) {
        const method = link.match(/^(\[\[([a-zA-Z]*)]])$/)[2];
        if(this[method]) {
          this[method]();
        }
      }
    },
    compileContent(content) {
      const html = content
        .replace('[[resendEmail]]', '<a class="btn-link cursor-pointer" @click.prevent="verifyEmail">' + this.$t('Resend Email') + '</a>')
        .replace('[[unpauseAccount]]', '<a class="btn-link cursor-pointer" @click.prevent.stop="unpauseAccount">' + this.$t('Unpause Account') + '</a>');
      const component = Vue.compile(`<div>${html}</div>`);
      component.methods = {
        verifyEmail: this.verifyEmail,
        unpauseAccount: this.unpauseAccount,
      }
      return component;
    },
    verifyEmail: function() {
      this.$api.verification.sendValidationEmail().then(() => {
        this.$emit('refresh');
        this.notify(this.$bvToast, this.$t('Email sent, please check your inbox'), null, 'success');
      });
    },
    unpauseAccount: function () {
      this.$store.dispatch('changeAlertStatus', true);
    }
  },
}
</script>

<style scoped lang="scss">
.notification__action {
  .btn {
    min-width: 150px;
  }
}
::v-deep .notification__content {
  a {
    text-decoration: underline;
    text-decoration-color: $theme-secondary;
  }
}
.simple {
  ::v-deep  .toast {
    box-shadow: none;
  }
  .inner-wrap {
    min-height: 52px;
  }
}

.dismiss-button {
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}

</style>
